"use client"

import { useState } from "react"
import { Loader2, MailCheck } from "lucide-react"
import { kirimTautanMasuk } from "@/modules/akun/actions/auth-actions"
import { useHitungMundur } from "@/modules/akun/hooks/use-hitung-mundur"
import { useCaptcha } from "@/modules/captcha/hooks/use-captcha"
import { CaptchaField } from "@/modules/captcha/ui/captcha-field"
import { KolomTeks, PesanGalat } from "@/modules/akun/ui/kolom"

const JEDA_KIRIM_ULANG_DETIK = 60

export function FormTautanEmail({ teksTombol, lanjut = null }: { teksTombol: string; lanjut?: string | null }) {
  const captcha = useCaptcha()
  const jeda = useHitungMundur(JEDA_KIRIM_ULANG_DETIK)
  const [email, setEmail] = useState("")
  const [terkirim, setTerkirim] = useState(false)
  const [memproses, setMemproses] = useState(false)
  const [galat, setGalat] = useState<string | null>(null)

  const kirim = async () => {
    if (memproses) return
    setGalat(null)
    setMemproses(true)
    const hasil = await kirimTautanMasuk({ email, lanjut, tokenCaptcha: captcha.token ?? undefined })
    setMemproses(false)
    captcha.reset()

    if (!hasil.ok) {
      setGalat(hasil.pesan)
      return
    }
    setTerkirim(true)
    jeda.mulai()
  }

  if (terkirim) {
    return (
      <div className="space-y-4 text-center">
        <span className="mx-auto grid h-14 w-14 place-items-center rounded-full bg-success/15 text-success">
          <MailCheck className="h-7 w-7" />
        </span>
        <div className="space-y-1">
          <p className="font-display text-lg font-semibold text-foreground">Cek email kamu</p>
          <p className="text-sm text-muted-foreground">
            Tautan dikirim ke <span className="font-medium text-foreground">{email.trim().toLowerCase()}</span> dan berlaku 10 menit.
          </p>
        </div>
        <PesanGalat pesan={galat} />
        <div className="flex flex-col gap-2">
          <button type="button" onClick={kirim} disabled={jeda.sisa > 0 || memproses || captcha.perluDiselesaikan} className="btn-primary w-full">
            {memproses ? <Loader2 className="h-4 w-4 animate-spin" /> : jeda.sisa > 0 ? `Kirim ulang dalam ${jeda.sisa} dtk` : "Kirim ulang"}
          </button>
          <button type="button" onClick={() => setTerkirim(false)} className="h-10 text-sm font-medium text-muted-foreground hover:text-foreground">
            Ganti email
          </button>
        </div>
        <CaptchaField captcha={captcha} />
      </div>
    )
  }

  return (
    <form
      className="space-y-4"
      onSubmit={(event) => {
        event.preventDefault()
        kirim()
      }}
    >
      <KolomTeks label="Email" type="email" value={email} onChange={setEmail} autoComplete="email" inputMode="email" placeholder="nama@email.com" disabled={memproses} required />
      <CaptchaField captcha={captcha} />
      <PesanGalat pesan={galat} />
      <button type="submit" disabled={memproses || captcha.perluDiselesaikan || email.trim().length < 5} className="btn-primary w-full">
        {memproses ? <Loader2 className="h-4 w-4 animate-spin" /> : teksTombol}
      </button>
    </form>
  )
}
